import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Wait_Index from '@/components/Wait_Index'
import Yindex from '@/components/YIndex'
import CheckDataDetail from '@/components/Check/CheckDataDetail.vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/wait_Index',
      name: 'Wait_Index',
      // path: '/index',
      // name: 'Yndex',
      meta: {
         requireAuth: true
      },
      children: [
              //主页链接
              {
                path: '/index',
                name: 'Yndex',
                component:() => import('@/components/YIndex.vue')
              },
              // 设置Munber的所有链接
              {
                path: '/Unit',
                name: 'Unit',
                component:() => import('@/components/Munber/Unit.vue')
              },{
                path: '/User',
                name: 'User',
                component:() => import('@/components/Munber/User.vue')
              },{
                path: '/Department',
                name: 'Department',
                component:() => import('@/components/Munber/Department.vue')
              },{
                path: '/Category',
                name: 'Category',
                component:() => import('@/components/Munber/Category.vue')
              },{
                path: '/Place',
                name: 'Place',
                component:() => import('@/components/Munber/Place.vue')
              },{
                path: '/Log',
                name: 'Log',
                component:() => import('@/components/Munber/Log.vue')
              }

              // 资产property所有链接
              ,{
                path: '/PropertyBack',
                name: 'PropertyBack',
                component:() => import('@/components/Property/Property_Back.vue')
              },{
                path: '/PropertyBorrow',
                name: 'PropertyBorrow',
                component:() => import('@/components/Property/Property_Borrow.vue')
              },{
                path: '/PropertyIndex',
                name: 'PropertyIndex',
                component:() => import('@/components/Property/Property_Index.vue')
              },{
                path: '/PropertyChange',
                name: 'PropertyChange',
                component:() => import('@/components/Property/Property_Change.vue')
              },{
                path: '/PropertyData',
                name: 'PropertyData',
                component:() => import('@/components/Property/Property_Data.vue')
              },{
                path: '/PropertyDeal',
                name: 'PropertyDeal',
                component:() => import('@/components/Property/Property_Deal.vue')
              },{
                path: '/PropertyDaioBo',
                name: 'PropertyDaioBo',
                component:() => import('@/components/Property/Property_DiaoBo.vue')
              },{
                path: '/PropertyEdit',
                name: 'PropertyEdit',
                component:() => import('@/components/Property/Property_Edit.vue')
              },{
                path: '/PropertyGet',
                name: 'PropertyGet',
                component:() => import('@/components/Property/Property_Get.vue')
              },{
                path: '/PropertyInsert',
                name: 'PropertyInsert',
                component:() => import('@/components/Property/Property_Insert.vue')
              },{
                path: '/PropertyInsertData',
                name: 'PropertyInsertData',
                component:() => import('@/components/Property/Property_Insert_Data.vue')
              },{
                path: '/PropertyInsertMore',
                name: 'PropertyInsertMore',
                component:() => import('@/components/Property/Property_Insert_More.vue')
              },{
                path: '/PropertyInsertRecord',
                name: 'PropertyInsertRecord',
                component:() => import('@/components/Property/Property_Insert_Record.vue')
              },{
                path: '/PropertyMaintenance',
                name: 'PropertyMaintenance',
                component:() => import('@/components/Property/Property_Maintenance.vue')
              },{
                path: '/PropertyMyChange',
                name: 'PropertyMyChange',
                component:() => import('@/components/Property/Property_MyChange.vue')
              },{
                path: '/PropertyMyChangeDeatil',
                name: 'PropertyMyChangeDeatil',
                component:() => import('@/components/Property/Property_MyChangeDeatil.vue')
              },{
                path: '/PropertyMyData',
                name: 'PropertyMyData',
                component:() => import('@/components/Property/Property_MyData.vue')
              },{
                path: '/PropertySet',
                name: 'PropertySet',
                component:() => import('@/components/Property/Property_Set.vue')
              },


              //杨经理的清查模块Detect
              {
                path: '/DetectIndex',
                name: 'DetectIndex',
                component:() => import('@/components/Detect/DetectIndex.vue')
              },{
                path: '/DetectCreate',
                name: 'DetectCreate',
                component:() => import('@/components/Detect/DetectCreate.vue')
              },{
                path: '/DetectAllDataDetail',
                name: 'DetectAllDataDetail',
                component:() => import('@/components/Detect/DetectAllDataDetail.vue')
              },

              //盘点模块
              {
                path: '/CheckIndex',
                name: 'CheckIndex',
                component:() => import('@/components/Check/CheckIndex.vue')
              },{
                path: '/CheckData',
                name: 'CheckData',
                component:() => import('@/components/Check/CheckData.vue')
              },{
                path: '/CheckMission',
                name: 'CheckMission',
                component:() => import('@/components/Check/CheckMission.vue')
              },{
                path: '/CheckErrorData',
                name: 'CheckErrorData',
                component:() => import('@/components/Check/CheckErrorData.vue')
              },{
                path: '/CheckWaitErrorData',
                name: 'CheckWaitErrorData',
                component:() => import('@/components/Check/CheckWaitErrorData.vue')
              }








            ],
      components:{
        default: Wait_Index,
      },
    },

  ],

})



// WEBPACK FOOTER //
// ./src/router/index.js